export default {
  label: {
    message: {
      error: {
        addEmail: 'Adicione algum email.',
        addAllEmails: 'Todos emails precisam ser validos.',
      },
    },
  },
};
